/* eslint-disable react-hooks/exhaustive-deps */
import { Pencil } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Card, Col, Row, Table } from 'react-bootstrap'
import Loader from '../../../components/atoms/Loader/index'
import TableAction from '../../../components/atoms/Table/TableAction'
import TablePagination from '../../../components/atoms/Table/TablePagination'
import api from '../../../config/AxiosInstance'
import '../../../styles/style.css'
import MapEditorDetail from './Detail'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  backgroundColor: '#f8f9fa',
  color: '#333333',
  fontWeight: '700',
  borderBottom: '1px solid #e9ecef',
  textTransform: 'uppercase',
  fontSize: '0.85rem'
}

const MapEditor = () => {
  const [metaData, setMetaData] = useState({
    per_page: 10,
    current_page: 1,
    total_row: 0,
    total_page: 0
  })
  const [isLoading, setIsLoading] = useState(false)
  const [mapEditors, setMapEditors] = useState([])
  const [editData, setEditData] = useState({})
  const [step, setStep] = useState(0)

  const handlePageClick = async (data) => {
    const current_page = data.selected + 1
    setMetaData({
      ...metaData,
      current_page: current_page
    })
    window.scrollTo(0, 0)
  }

  useEffect(() => {
    fetchMapEditors()
  }, [metaData.current_page, metaData.per_page])

  function handleOnChangeMeta(e) {
    setMetaData({
      ...metaData,
      per_page: parseInt(e.target.value, 10),
      current_page: 1
    })
  }

  function handleDetailData(id) {
    setEditData(id)
  }

  function handleResetDetailData() {
    setEditData({})
    if (Number(step) === 1) {
      setStep(0)
    }
  }

  function handleStep(value) {
    setStep(value)
  }

  async function fetchMapEditors() {
    setIsLoading(true)
    try {
      const params = new URLSearchParams({
        per_page: metaData.per_page,
        page: metaData.current_page
      })

      const res = await api.get(
        `/settings/map/editor/warehouse/all?${params.toString()}`
      )

      if (res.data.data.length > 0) {
        setMapEditors(res.data.data)
        setMetaData(res.data.metadata)
      } else {
        setMapEditors([])
      }
    } catch (err) {
      setMapEditors([])
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="container-fluid px-4">
      {Object.keys(editData).length === 0 ? (
        <>
          <Row className="mb-3">
            <Col>
              <h3 style={headerTitleStyle}>Map Editor</h3>
            </Col>
          </Row>

          <div className="row">
            <div className="col-12">
              <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
                <Table hover responsive className="mb-0 b-table-frameless">
                  <thead style={tableHeaderStyle}>
                    <tr>
                      <th className="p-2 align-middle ps-4">No</th>
                      <th className="p-2 align-middle">Warehouse</th>
                      <th
                        className="p-2 align-middle text-center pe-4"
                        width="15%"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading && (
                      <tr>
                        <td colSpan={3} className="text-center p-5">
                          <Loader />
                        </td>
                      </tr>
                    )}
                    {!isLoading && mapEditors.length === 0 && (
                      <tr>
                        <td colSpan={3} className="text-center p-5 text-muted">
                          No data available
                        </td>
                      </tr>
                    )}
                    {!isLoading &&
                      mapEditors.length > 0 &&
                      mapEditors?.map((mapEditor, i) => (
                        <TbodyRow
                          data={mapEditor}
                          key={mapEditor.id}
                          row={
                            (metaData.current_page - 1) * metaData.per_page +
                            i +
                            1
                          }
                          onHandleDetailData={() => handleDetailData(mapEditor)}
                        />
                      ))}
                  </tbody>
                </Table>
                {mapEditors.length > 0 && (
                  <div className="p-3 border-top bg-white">
                    <TablePagination
                      meta={metaData}
                      handleOnChangeMeta={handleOnChangeMeta}
                      handlePageChange={handlePageClick}
                    />
                  </div>
                )}
              </Card>
            </div>
          </div>
        </>
      ) : (
        <>
          <MapEditorDetail
            data={editData}
            step={step}
            onHandleResetDetailData={() => handleResetDetailData()}
            onHandleStep={handleStep}
          />
        </>
      )}
    </div>
  )
}

function TbodyRow({ data, onHandleDetailData, row }) {
  return (
    <tr key={data.id}>
      <td className="p-2 align-middle ps-4 text-muted fw-bold">{row}</td>
      <td className="p-2 align-middle text-dark fw-medium">
        {data.warehouse_name}
      </td>
      <td className="p-2 align-middle text-center pe-4">
        <TableAction>
          <button
            className="btn btn-light shadow-sm rounded d-flex align-items-center justify-content-center px-3 py-1"
            style={{ height: '32px', fontSize: '0.8rem' }}
            onClick={() => onHandleDetailData()}
          >
            <Pencil size={11} className="text-secondary me-2" />
            <span className="fw-bold text-secondary">Update</span>
          </button>
        </TableAction>
      </td>
    </tr>
  )
}
export default MapEditor
